import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';
import { BorderImageInterface } from './border-image.interface';
import mapPropValues from '@finder/shared/utils/object/mapPropValues';

const BORDER_IMAGE_PROPS = [
    'borderImageBorder',
    'borderImageBorderMobile',
    'borderImageOutset',
    'borderImageOutsetMobile',
    'borderImageSlice',
    'borderImageSliceMobile',
    'borderImageWidth',
    'borderImageWidthMobile',
];

const BORDER_IMAGE_MAP_PROPS = {
    borderImageBorder: '--border-image-border',
    borderImageBorderMobile: '--border-image-border-mobile',
    borderImageOutset:  '--border-image-outset',
    borderImageOutsetMobile: '--border-image-outset-mobile',
    borderImageSlice: '--border-image-slice',
    borderImageSliceMobile:  '--border-image-slice-mobile',
    borderImageWidth: '--border-image-width',
    borderImageWidthMobile: '--border-image-width-mobile',
};

@Directive({
    selector: '[finderBorderImage]',
    standalone: true
})

export class BorderImageDirective implements AfterViewInit{
    private borderImageData: any;

    @Input()
    set finderBorderImage(data: BorderImageInterface) {
        this.borderImageData = data;
    }

    constructor(
        private element: ElementRef
    ) {}

    ngAfterViewInit() {
        this.setBorderImageAttributes();
    }

    setBorderImageAttributes() {
        if (!this.borderImageData) {
            return;
        }

        this.element.nativeElement.style.setProperty('--border-image-source-mobile', this.borderImageData.mobile.url);
        this.element.nativeElement.style.setProperty('--border-image-source', this.borderImageData.desktop.url);

        BORDER_IMAGE_PROPS.forEach((prod) => {
            const { prop, propValueFromData } = mapPropValues(prod, this.borderImageData);

            // Don't bother if there is no value
            if (!propValueFromData) {
                return;
            }

            this.element.nativeElement.style.setProperty(BORDER_IMAGE_MAP_PROPS[prop], propValueFromData);
        });
    }
}
